<template>
    <!-- /**
 * スライドコンポーネント
 * 外部ライブラリswiper@6.x を使用 -> https://swiperjs.com/vue
 * autoplayパラメタが正しく動作しないため、swiperInstanceを初期化した際に取得しそれを操作する
 */ -->
    <div class="material">
        <swiper
            class="border border-dark"
            :speed="0"
            :navigation="{
                nextEl: '.next-button',
                prevEl: '.prev-button',
            }"
            @init="setSwiperInstance"
            @reachBeginning="isHideBackSlideButton = true"
            @reachEnd="showActionButton"
            @fromEdge="
                (isHideBackSlideButton = false), (isHideNextSlideButton = false)
            "
        >
            <swiper-slide v-for="i in slides.num" :key="i">
                <img
                    :src="`/cedu/images/${readdir}/slide${
                        slides.start + i
                    }.PNG`"
                    class="w-65 d-block mx-auto"
                />
            </swiper-slide>
        </swiper>
        <!-- コントロールパネル全体をスロットで各ページごとにカスタマイズで入れ込みたかったけど
        速度調整などの機能をswiperコンポーネントがあるこのコンポーネントで行っているので
        一応カスタマイズすべき部分だけ（遷移先など）slotで渡せるように実装してある -->
        <!-- ストーリー編以外のコントロールパネル -->
        <div v-if="!storyMode" class="mt-3">
            <div class="text-center">
                <input
                    class="btn btn-outline-dark me-1 prev-button"
                    :class="{ invisible: isHideBackSlideButton }"
                    type="button"
                    value="前に戻る"
                />
                <input
                    class="btn btn-outline-dark next-button"
                    :class="{ invisible: isHideNextSlideButton }"
                    type="button"
                    value="次に進む"
                />
            </div>
            <div class="text-center mt-2">
                <!-- <input class="btn btn-outline-dark" type="button" value="前回の続きから" @click="slidesw(2)" /> -->
                <router-link class="btn btn-outline-dark me-1" to="/"
                    >学習項目一覧に戻る</router-link
                >
                <!-- 移動先は親がカスタムする -->
                <slot name="next-contents"></slot>
            </div>
        </div>
        <!-- ストーリー編のコントロールパネル -->
        <div v-if="storyMode" class="mt-3">
            <div class="text-center">
                <input
                    class="btn btn-outline-dark d-block mx-auto mt-2 mb-1"
                    type="button"
                    :value="startButtonText"
                    :disabled="swiperInsance.isEnd"
                    @click="slideStartOrStop"
                />
                <div class="text-center mb-1">
                    <div v-show="isShowAnswerButton" class="mx-auto mb-1">
                        <input
                            v-show="
                                Object.keys(contentsJson[qnum]['A']).length > 0
                            "
                            class="btn btn-outline-dark"
                            type="button"
                            value="A"
                            @click="answer('A')"
                        />
                        <input
                            v-show="
                                Object.keys(contentsJson[qnum]['B']).length > 0
                            "
                            class="btn btn-outline-dark mx-1"
                            type="button"
                            value="B"
                            @click="answer('B')"
                        />
                        <input
                            v-show="
                                Object.keys(contentsJson[qnum]['C']).length > 0
                            "
                            class="btn btn-outline-dark"
                            type="button"
                            value="C"
                            @click="answer('C')"
                        />
                    </div>
                    <div class="mx-auto mb-1">
                        <a
                            v-show="swiperInsance.isEnd"
                            class="btn btn-outline-dark me-1"
                            @click="replay"
                            >もう一度見る</a
                        >
                        <a
                            v-show="isShowNextButton"
                            class="btn btn-outline-dark me-1"
                            @click="gotoNextContents"
                            >{{ nextContents }}へ進む</a
                        >
                    </div>
                </div>
                <div class="mx-auto">
                    <div id="TorF">
                        <span>Q1 {{ result["q1"] }}</span>
                        <span class="mx-3">Q2 {{ result["q2"] }}</span>
                        <span class="me-3">Q3 {{ result["q3"] }}</span>
                        <span v-if="hasQ4" class="me-3"
                            >Q4 {{ result["q4"] }}</span
                        >
                    </div>
                    <input
                        class="btn btn-outline-dark"
                        type="button"
                        value="高速"
                        :disabled="option.delay == 2500"
                        @click="changeSpeed(2500)"
                    />
                    <input
                        class="btn btn-outline-dark mx-1"
                        type="button"
                        value="中速"
                        :disabled="option.delay == 4000"
                        @click="changeSpeed(4000)"
                    />
                    <input
                        class="btn btn-outline-dark"
                        type="button"
                        value="低速"
                        :disabled="option.delay == 6000"
                        @click="changeSpeed(6000)"
                    />
                </div>
            </div>
        </div>
        <div class="mt-3">
            <slot name="word"></slot>
        </div>
    </div>
</template>

<script>
import SwiperCore, { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";

import { reactive } from "vue";

SwiperCore.use([Navigation, Autoplay]);

export default {
    name: "material",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        /*
        contentsJson: slide data json
        +
        story:
            q*: 問題番号
            Q: 問題導入
            A, B(, C): 回答番号のスライド
                start: 開始スライドのインデックス（0を最初とする）,
                num: スライド数
            ans: 正解の選択肢

        answer and base:
            start: 開始スライドのインデックス（0を最初）,
            num: スライド数
        */
        contentsJson: {
            type: Object,
            required: true,
        },
        // 読み込む画像フォルダ
        readdir: {
            type: String,
            required: true,
        },
        // ストーリー編かどうか
        storyMode: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        // 一部使えないプロパティがあったのでインスタンスを操作できるようにしている
        const swiperInsance = reactive({});
        return { swiperInsance };
    },
    data() {
        return {
            option: {}, // 参照用
            qnum: "q1", // 問題番号
            qsec: "Q", // 問題セクション
            result: { q1: "", q2: "", q3: "" }, // 回答結果
            startButtonText: "開始",
            nextContents: "続き",
            isShowAnswerButton: false, // 選択肢ボタン表示フラグ
            isShowNextButton: false, // 次のコンテンツへのボタン表示フラグ
            contentsName: this.$route.params.contents,
            isClear: true,
            isHideBackSlideButton: true,
            isHideNextSlideButton: false,
        };
    },
    created() {
        if ("q4" in this.contentsJson) {
            this.result.q4 = "";
        }
    },
    computed: {
        // 選択したセクションのスライド
        slides() {
            if (this.storyMode) {
                return this.contentsJson[this.qnum][this.qsec];
            } else {
                return this.contentsJson;
            }
        },
        hasQ4() {
            return "q4" in this.contentsJson;
        },
    },
    watch: {
        slides() {
            this.swiperInsance.slideTo(0, 300);
        },
    },
    methods: {
        // swiperインスタンスを取得
        setSwiperInstance(swiper) {
            this.swiperInsance = swiper;
            this.swiperInsance.params.autoplay.delay = 4000;
            this.option.delay = this.swiperInsance.params.autoplay.delay;
        },
        slideStartOrStop() {
            if (this.swiperInsance.autoplay.running) {
                this.startButtonText = "再開";
                this.swiperInsance.autoplay.stop();
            } else {
                this.startButtonText = "停止";
                this.swiperInsance.autoplay.start();
            }
            this.swiperInsance.params.autoplay.stopOnLastSlide = true;
        },
        changeSpeed(speed) {
            this.swiperInsance.params.autoplay.delay = speed;
            this.option.delay = this.swiperInsance.params.autoplay.delay;
        },
        replay() {
            this.swiperInsance.slideTo(0, 0);
            this.isShowAnswerButton = false;
            this.isShowNextButton = false;
            this.startButtonText = "停止";
            this.swiperInsance.autoplay.start();
        },
        answer(ans) {
            this.qsec = ans;
            if (this.contentsJson[this.qnum]["ans"] == ans) {
                this.result[this.qnum] = "〇";
            } else {
                this.result[this.qnum] = "×";
                this.isClear = false;
            }
            this.startButtonText = "再開";
            this.isShowAnswerButton = false;
        },
        setHistory() {
            this.$store.commit("setCompleteStatus", {
                contents:
                    this.$route.params.contents.substring(0, 1).toUpperCase() +
                    this.$route.params.contents.substring(1),
                page: "story",
                isComplete: this.isClear,
            });
        },
        showActionButton() {
            if (this.qsec == "Q") {
                this.isShowAnswerButton = this.swiperInsance.isEnd;
            } else {
                this.isShowNextButton = this.swiperInsance.isEnd;
            }
            this.isHideNextSlideButton = true;
        },
        gotoNextContents() {
            // 回答後にスライドがある場合表示
            if (this.qsec != "F" && "F" in this.contentsJson[this.qnum]) {
                this.qsec = "F";
                this.nextContents = "解説編";
                this.isShowAnswerButton = false;
                this.isShowNextButton = false;
                this.startButtonText = "再開";
            } else {
                switch (this.qnum) {
                    case "q1":
                        this.qnum = "q2";
                        this.qsec = "Q";
                        this.isShowAnswerButton = false;
                        this.isShowNextButton = false;
                        this.startButtonText = "再開";
                        break;
                    case "q2":
                        this.qnum = "q3";
                        this.qsec = "Q";
                        this.isShowAnswerButton = false;
                        this.isShowNextButton = false;
                        this.startButtonText = "再開";
                        break;
                    case "q3":
                        if (this.hasQ4) {
                            this.qnum = "q4";
                            this.qsec = "Q";
                            this.isShowAnswerButton = false;
                            this.isShowNextButton = false;
                            this.startButtonText = "再開";
                        } else {
                            this.setHistory();
                            this.$router.push(`/answer/${this.contentsName}`);
                        }
                        break;
                    case "q4":
                        this.setHistory();
                        this.$router.push(`/answer/${this.contentsName}`);
                        break;
                }
            }
            // this.isShowNextButton = false;
        },
    },
};
</script>
